export default __webpack_public_path__ + "static/media/CNo.77-3.19d03ade.jpg";